import React from "react";
import StatisticsCard from "../../common/StatisticsCard";

const StatisticsCards = ({ dashboardData }) => {
  const stats = [
    {
      label: "Total Registered Voters",
      value: (dashboardData?.total_registered_voters ?? 0).toLocaleString(),
      bgColor: "bg-indigo-100",
      textColor: "text-indigo-600",
      description: "Registered Voter Count",
    },
    {
      label: "Total Precincts",
      value: (dashboardData?.total_precincts ?? 0).toLocaleString(),
      bgColor: "bg-yellow-100",
      textColor: "text-yellow-600",
      description: "Number of Precincts",
    },
    {
      label: "Avg. Voters per Precinct",
      value: (dashboardData?.average_voter_per_precinct ?? 0).toLocaleString(),
      bgColor: "bg-green-100",
      textColor: "text-green-600",
      description: "Average Precinct Size",
    },
  ];

  return (
    <StatisticsCard
      stats={stats}
      columns="xl:grid-cols-3" 
      text="text-xs" 
    />
  );
};

export default StatisticsCards;
